import {
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles
} from '@material-ui/core';
import React, { FC } from 'react';

import arrow from '../../../../static/images/arrow-pointer-solid.svg';
import qrCode from '../../../../static/images/qrcode-solid.svg';
import mobile from '../../../../static/images/mobile-screen-button-solid.svg';

const CustomStepConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    marginLeft: 15,
    marginRight: 15
  }
})(StepConnector);

const useCustomStepIconStyles = makeStyles(theme => ({
  root: {
    zIndex: 1,
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: '3px solid #00796b'
  },
  icon: {
    width: theme.spacing(2)
  }
}));

function CustomStepIcon({ icon }: { icon: string }) {
  const classes = useCustomStepIconStyles();
  const icons: Record<string, string> = {
    1: arrow,
    2: qrCode,
    3: mobile
  };

  return (
    <div className={classes.root}>
      <img className={classes.icon} alt="icon" src={icons[icon]} />
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

function getSteps() {
  return ['Submit your order', 'Scan the QR code', `Pay on your Apple device`];
}

const ApplePayStep: FC = () => {
  const classes = useStyles();
  const [activeStep] = React.useState(-1);
  const steps = getSteps();

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<CustomStepConnector />}
      >
        {steps.map(label => (
          <Step key={label}>
            <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default ApplePayStep;
